import React from 'react'

const SidePlanningIcon = (
  <>
    <path
      d="M16.9165 19.5833H1.08317C0.853171 19.5833 0.666504 19.3967 0.666504 19.1667V1.66667C0.666504 1.43667 0.853171 1.25 1.08317 1.25H16.9165C17.1465 1.25 17.3332 1.43667 17.3332 1.66667V19.1667C17.3332 19.3967 17.1465 19.5833 16.9165 19.5833Z"
      fill="#C6A279"
    />
    <path
      d="M15.2497 17.917H2.74967C2.51967 17.917 2.33301 17.7303 2.33301 17.5003V3.33366C2.33301 3.10366 2.51967 2.91699 2.74967 2.91699H15.2497C15.4797 2.91699 15.6663 3.10366 15.6663 3.33366V17.5003C15.6663 17.7303 15.4797 17.917 15.2497 17.917Z"
      fill="#E6E6E6"
    />
    <path
      d="M12.3333 4.58366H10.6667C10.4367 4.58366 10.25 4.39699 10.25 4.16699C10.25 3.47783 9.68917 2.91699 9 2.91699C8.31083 2.91699 7.75 3.47783 7.75 4.16699C7.75 4.39699 7.56333 4.58366 7.33333 4.58366H5.66667C5.43667 4.58366 5.25 4.39699 5.25 4.16699V0.833659C5.25 0.603659 5.43667 0.416992 5.66667 0.416992H12.3333C12.5633 0.416992 12.75 0.603659 12.75 0.833659V4.16699C12.75 4.39699 12.5633 4.58366 12.3333 4.58366Z"
      fill="#B3B3B3"
    />
    <path
      d="M12.5319 9.83529C12.5336 9.44658 12.414 9.06701 12.1898 8.74947C11.9656 8.43194 11.6479 8.19226 11.281 8.06385C10.9141 7.93544 10.5163 7.92469 10.143 8.03309C9.76975 8.1415 9.43957 8.36366 9.19853 8.66862C9.03871 8.46688 8.83894 8.30032 8.61175 8.17938C8.38456 8.05844 8.13484 7.98572 7.87823 7.96578C7.62163 7.94584 7.36367 7.97911 7.12052 8.0635C6.87738 8.1479 6.65428 8.2816 6.46521 8.45623C6.27614 8.63085 6.12517 8.84265 6.02176 9.07834C5.91835 9.31403 5.86473 9.56854 5.86426 9.82591C5.86379 10.0833 5.91648 10.338 6.01903 10.5741C6.12157 10.8101 6.27177 11.0225 6.4602 11.1978L9.19853 13.9124L11.9369 11.199C12.1243 11.0247 12.2739 10.8137 12.3762 10.5791C12.4786 10.3444 12.5316 10.0913 12.5319 9.83529Z"
      fill="#ED7064"
    />
  </>
)

export default SidePlanningIcon
